var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntryIconShop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1049_5526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.65 10.22C26.65 10.12 26.63 10.03 26.59 9.94L23.77 2.64C23.62 2.25 23.25 2 22.84 2H4.82001C4.41001 2 4.04001 2.25 3.89001 2.64L1.07001 9.93C1.03001 10.02 1.02001 10.12 1.01001 10.21C1.01001 10.21 1.01001 10.26 1.01001 10.28C1.01001 10.35 1.01001 10.42 1.03001 10.5C1.12001 12.11 1.99001 13.51 3.25001 14.35V24.04C3.25001 24.59 3.70001 25.04 4.25001 25.04H23.41C23.96 25.04 24.41 24.59 24.41 24.04V14.35C25.68 13.52 26.54 12.11 26.63 10.5C26.65 10.43 26.65 10.36 26.65 10.28C26.65 10.26 26.65 10.23 26.65 10.21V10.22ZM22.15 4L24.2 9.3H18.73L18.29 4H22.16H22.15ZM11.38 4H16.28L16.72 9.3H10.94L11.38 4V4ZM16.56 11.3C16.13 12.39 15.07 13.16 13.83 13.16C12.59 13.16 11.53 12.39 11.1 11.3H16.56ZM5.51001 4H9.38001L8.94001 9.3H3.46001L5.51001 4ZM8.68001 11.3C8.25001 12.39 7.19001 13.16 5.95001 13.16C4.71001 13.16 3.65001 12.39 3.22001 11.3H8.68001ZM16.25 22.91H11.42V21.05C11.42 19.72 12.5 18.63 13.84 18.63C15.18 18.63 16.26 19.71 16.26 21.05V22.91H16.25ZM22.41 23.05H18.25V21.05C18.25 18.62 16.27 16.63 13.83 16.63C11.39 16.63 9.41001 18.61 9.41001 21.05V23.05H5.25001V15.1C5.48001 15.13 5.71001 15.17 5.94001 15.17C7.56001 15.17 8.98001 14.38 9.88001 13.18C10.78 14.38 12.21 15.17 13.82 15.17C15.43 15.17 16.86 14.38 17.76 13.18C18.66 14.38 20.09 15.17 21.7 15.17C21.94 15.17 22.16 15.13 22.39 15.1V23.05H22.41ZM21.72 13.17C20.48 13.17 19.42 12.4 18.99 11.31H24.45C24.02 12.4 22.96 13.17 21.72 13.17Z",
    fill: "#82BCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1049_5526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.66,
    height: 23.04,
    fill: "white",
    transform: "translate(1 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntryIconShop);
export default __webpack_public_path__ + "static/media/entry_icon_shop.7e17298f1c848cc81491be5b89d47420.svg";
export { ForwardRef as ReactComponent };